import { CssBaseline, StyledEngineProvider } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useMemo } from 'react';
import useConfig from "../hooks/theme/useConfig";
import { TOOLBAR_MAX_HEIGHT } from "./config";
import componentsOverride from './overrides';
import Palette from "./palette.jsx";
import CustomShadows from './shadows.jsx';
import Typography from './typography.jsx';

// ==============================|| DEFAULT THEME - MAIN  ||============================== //

export default function ThemeCustomization({ children }) {
	const { themeDirection, mode, presetColor, fontFamily, fontFamilySpecial } = useConfig()
	const theme = useMemo(() => Palette(mode, presetColor), [mode, presetColor])
	const themeTypography = useMemo(() => Typography(fontFamily, fontFamilySpecial), [fontFamily])
	const themeCustomShadows = useMemo(() => CustomShadows(theme), [theme]);
	
	const themeOptions = useMemo(
		() => ({
			breakpoints: {
				values: {
					xs: 0,
					sm: 660,
					md: 1024,
					lg: 1266,
					xl: 1440
				}
			},
			direction: themeDirection,
			mixins: {
				toolbar: {
					minHeight: TOOLBAR_MAX_HEIGHT,
					paddingTop: 8,
					paddingBottom: 8
				}
			},
			palette: theme.palette,
			customShadows: themeCustomShadows,
			typography: themeTypography,
			spacing: 8,
			shape: {
				borderRadius: 4,
			},
		}),
		[theme.palette, themeCustomShadows, themeTypography, themeDirection]
	);
	
	const themes = createTheme(themeOptions);
	themes.components = componentsOverride(themes);
	
	return (
		<StyledEngineProvider injectFirst>
			<ThemeProvider theme={themes}>
				<CssBaseline/>
				{children}
			</ThemeProvider>
		</StyledEngineProvider>
	);
}